// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3h7iu","selected":"Chip_selected__2Tq4E"};